// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.champ-siret-saisie {
  position: relative;
}

/* Place a droite pour le compteur et le spinner, poses par-dessus le champ. */
.champ-siret-saisie input {
  width: 100%;
  padding-right: 14rem;
}

.champ-siret-indicateurs {
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 0.8rem;
  pointer-events: none;
}

.champ-siret input.input-error {
  border-color: #dc2626;
}

.champ-siret-spinner {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border: 2px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: champ-siret-rotation 0.8s linear infinite;
}

@keyframes champ-siret-rotation {
  to { transform: rotate(360deg); }
}

.champ-siret-compteur {
  font-size: 1.2rem;
  color: #6b7280;
  white-space: nowrap;
}

.champ-siret-compteur-complet {
  color: #16a34a;
}

.champ-siret-retour {
  margin: 0.6rem 0 0;
  font-size: 1.3rem;
}

.champ-siret-retour-alerte {
  color: #f97316;
}
`, "",{"version":3,"sources":["webpack://./src/composants/ChampSiret/ChampSiret.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".champ-siret-saisie {\n  position: relative;\n}\n\n/* Place a droite pour le compteur et le spinner, poses par-dessus le champ. */\n.champ-siret-saisie input {\n  width: 100%;\n  padding-right: 14rem;\n}\n\n.champ-siret-indicateurs {\n  position: absolute;\n  right: 1.2rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  pointer-events: none;\n}\n\n.champ-siret input.input-error {\n  border-color: #dc2626;\n}\n\n.champ-siret-spinner {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  border: 2px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: champ-siret-rotation 0.8s linear infinite;\n}\n\n@keyframes champ-siret-rotation {\n  to { transform: rotate(360deg); }\n}\n\n.champ-siret-compteur {\n  font-size: 1.2rem;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.champ-siret-compteur-complet {\n  color: #16a34a;\n}\n\n.champ-siret-retour {\n  margin: 0.6rem 0 0;\n  font-size: 1.3rem;\n}\n\n.champ-siret-retour-alerte {\n  color: #f97316;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
